import React, { Component } from 'react';
import Utils from '../../sources/Utils';
import Styles from './BaseComponent.cssmodule.less';
import Theme from '../../themes';

class BaseComponent extends Component {
    constructor(props) {
        super(props);
        this.Styles = Styles;
        this.themes = Theme;
        this.Utils = Utils;
    }

    getTheme(type, name) {
        const themeList = this.themes[type] || {};
        return themeList[name];
    }

    getVideoIdByYouTube(url) {
        return this.Utils.getVideoIdByYouTube(url);
    }

    getClipNoByNaver(url) {
        return this.Utils.getClipNoByNaver(url);
    }

    getLang(key) {
        return this.Utils.getLang(key);
    }

    format(fmtstr, ...args) {
        return this.Utils.format(fmtstr, args);
    }

    shuffleArray(items) {
        return this.Utils.shuffleArray(items);
    }

    render() {
        return <div>BaseComponent</div>;
    }
}

export default BaseComponent;



// WEBPACK FOOTER //
// ./components/CommonSet/BaseComponent.js